// extracted by mini-css-extract-plugin
export default {"app":"app_app__HqISE","header":"app_header__cuMBJ","logo":"app_logo__Pqe-y"};